/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumReminderType = "appointment" | "feedback" | "followup" | "outboundReferral" | "patientForm" | "recall" | "referral" | "telehealth" | "waitingRoom" | "%future added value";
export type TypographyReminderType_Reminder = {
    readonly type: EnumReminderType | null;
    readonly " $refType": "TypographyReminderType_Reminder";
};
export type TypographyReminderType_Reminder$data = TypographyReminderType_Reminder;
export type TypographyReminderType_Reminder$key = {
    readonly " $data"?: TypographyReminderType_Reminder$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TypographyReminderType_Reminder">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TypographyReminderType_Reminder",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "type": "Reminder",
  "abstractKey": null
};
(node as any).hash = 'f844ee58aed728cac2a52bd42fe85a69';
export default node;
